import React from 'react';

import { PurchaseOrderTableItem } from '@modules/advancement/purchaseOrder/duck/selectorsTyped';
import { Tooltip } from '@modules/shared';

interface PurchaseOrdersTableCustomRow {
  children?: React.ReactNode;
  shouldBeApprovable?: (record: PurchaseOrderTableItem) => void;
}

const PurchaseOrdersTableCustomRow: React.FC<
  PurchaseOrdersTableCustomRow
> = props => {
  const { children, shouldBeApprovable } = props;

  // check if children is undefined or null or not an array
  // check if first array exist and has props
  if (
    !children ||
    !Array.isArray(children) ||
    !children[0] ||
    !('props' in children[0])
  ) {
    return <tr {...props}>{children}</tr>;
  }

  const { record } = children[0].props;
  const shouldDisable = shouldBeApprovable && shouldBeApprovable(record);

  return shouldDisable ? (
    <tr {...props} />
  ) : (
    <Tooltip
      title={`Position does not grant permission to approve.`}
      placement="top"
    >
      <tr {...props} />
    </Tooltip>
  );
};

export default PurchaseOrdersTableCustomRow;
